export const INVOICE_STATUS = Object.freeze({
    DRAFT:          'DRAFT',
    ISSUED:         'ISSUED',
    SENT:           'SENT',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    PAID:           'PAID',
    OVERDUE:        'OVERDUE',
    CANCELLED:      'CANCELLED',
    WRITTEN_OFF:    'WRITTEN_OFF',
    PENDING:        'PENDING', // backward compat
});

const toLabel = (s) =>
    s
        .toLowerCase()
        .split('_')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');

export const INVOICE_STATUS_OPTIONS = Object.values(INVOICE_STATUS)
    .filter(v => v !== 'PENDING')
    .map(v => ({ value: v, label: toLabel(v) }));
